import script from "./methodsProposal.vue?vue&type=script&lang=js"
export * from "./methodsProposal.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__